import { useMutation, useQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomToast } from "../components/useCustomToast";
const formatResponseForAPI = (question, value) => {
    const responseDto = {};
    switch (question.responseType) {
        case "SHORT_ANSWER":
        case "PARAGRAPH":
        case "EMAIL":
        case "URL":
        case "DROPDOWN":
            responseDto.textValue = value || null;
            break;
        case "MULTIPLE_CHOICE":
            responseDto.selectedOptions = value ? [value] : [];
            break;
        case "CHECKBOXES":
            responseDto.selectedOptions = Array.isArray(value) ? value : [];
            break;
        case "DATE":
            responseDto.dateValue = value || null;
            break;
        case "TIME":
            responseDto.timeValue = value || null;
            break;
        case "FILE_UPLOAD":
            responseDto.file = value || null;
            break;
    }
    return responseDto;
};
export const submitEventForm = async ({ responses, eventId, userId, }) => {
    const formData = new FormData();
    Object.entries(responses).forEach(([questionId, { question, value }]) => {
        if (value !== undefined && value !== null && value !== "") {
            const responseDto = formatResponseForAPI(question, value);
            if (responseDto.textValue !== undefined &&
                responseDto.textValue !== null) {
                formData.append(`responses[${questionId}].textValue`, responseDto.textValue);
            }
            if (responseDto.selectedOptions !== undefined &&
                responseDto.selectedOptions.length > 0) {
                responseDto.selectedOptions.forEach((option, index) => {
                    formData.append(`responses[${questionId}].selectedOptions[${index}]`, option);
                });
            }
            if (responseDto.dateValue !== undefined &&
                responseDto.dateValue !== null) {
                formData.append(`responses[${questionId}].dateValue`, responseDto.dateValue);
            }
            if (responseDto.timeValue !== undefined &&
                responseDto.timeValue !== null) {
                formData.append(`responses[${questionId}].timeValue`, responseDto.timeValue);
            }
            if (responseDto.file !== undefined && responseDto.file !== null) {
                formData.append(`responses[${questionId}].file`, responseDto.file);
            }
        }
    });
    const { data } = await API.post(`/api/v1/rbzo/events/restrictions/requests/${eventId}/${userId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};
export const useEventSubmission = () => {
    // const toast = useToast();
    const customToast = useCustomToast();
    return useMutation(submitEventForm, {
        onError: (error) => {
            console.error("Error submitting form:", error);
            customToast({
                title: "Error",
                description: "Error submitting form. Please try again.",
                status: "error",
            });
        },
    });
};
const getAccessStatus = async (eventId, userId) => {
    const { data } = await API.get(`/api/v1/rbzo/events/restrictions/has-access/${eventId}/${userId}`, {});
    return data;
};
export const useAccessStatus = (eventId, userId) => {
    return useQuery(["status", eventId, userId], () => getAccessStatus(eventId, userId), {
        enabled: !!eventId && !!userId,
    });
};
